var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "order-card",
      class: {
        "order-card-schedule": _vm.noValidPayment,
        "order-card-waiting": _vm.validPayment,
        "order-card-paid": _vm.paid,
        "order-card-provisioning": _vm.provisioning
      },
      on: { click: _vm.redirect }
    },
    [
      _c("Header", { attrs: { order: this.payable } }),
      _vm._v(" "),
      _c("Body", { attrs: { order: this.payable } }),
      _vm._v(" "),
      _c("Footer", { attrs: { noValidPayment: _vm.noValidPayment } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fb7aa0b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fb7aa0b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order/Components/Card/Index.vue
// module id = null
// module chunks = 